export function buildDealerCompanyListTableHeaders({ t }) {
  return [
    {
      value: "id",
      text: t("page.users.id"),
      thClass: "w-24",
      tdClass: "max-w-[2rem] min-w-[5rem]",
      disabled: true,
    },
    {
      value: "company",
      text: t("page.dealersCompany.company"),
      thClass: "w-[10rem]",
      tdClass: "max-w-[12rem] min-w-[10rem]",
    },
    {
      value: "user",
      text: t("page.dealersCompany.user"),
      thClass: "w-[5rem]",
      tdClass: "max-w-[10rem] min-w-[10rem]",
    },
    {
      value: "customer",
      text: t("page.dealersCompany.customer"),
      thClass: "w-[10rem]",
      tdClass: "max-w-[12rem] min-w-[10rem]",
    },
    {
      value: "taxNumber",
      text: t("page.dealersCompany.taxNumber"),
      thClass: "w-[8rem]",
      tdClass: "max-w-[10rem] min-w-[8rem]",
    },
    {
      value: "bonusProgramLevel",
      text: t("page.customers.bonusProgramLevel"),
      thClass: "w-[7rem]",
      tdClass: "max-w-[9rem] min-w-[7rem] capitalize",
    },
    {
      value: "status",
      text: t("page.dealersCompany.status"),
      thClass: "w-[7rem]",
      tdClass: "max-w-[9rem] min-w-[7rem]",
    },
  ];
}
